import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Play, ExternalLink, AlertCircle } from 'lucide-react';

// Streaming platforms for the grid - NO DEEZER, NO YOUTUBE MUSIC
const platforms = [
  { 
    id: 'spotify', 
    name: 'Spotify', 
    color: '#1DB954',
    icon: (
      <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
      </svg>
    )
  },
  { 
    id: 'appleMusic', 
    name: 'Apple Music', 
    color: '#FA243C',
    icon: (
      <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor">
        <path d="M23.994 6.124a9.23 9.23 0 00-.24-2.19c-.317-1.31-1.062-2.31-2.18-3.043a5.022 5.022 0 00-1.877-.726 10.496 10.496 0 00-1.564-.15c-.04-.003-.083-.01-.124-.013H5.986c-.152.01-.303.017-.455.026-.747.043-1.49.123-2.193.401-1.336.53-2.3 1.452-2.865 2.78-.192.448-.292.925-.363 1.408-.056.392-.088.785-.1 1.18 0 .032-.007.062-.01.093v12.223c.01.14.017.283.027.424.05.815.154 1.624.497 2.373.65 1.42 1.738 2.353 3.234 2.801.42.127.856.187 1.293.228.555.053 1.11.06 1.667.06h11.03a12.5 12.5 0 001.57-.1c.822-.106 1.596-.35 2.295-.81a5.046 5.046 0 001.88-2.207c.186-.42.293-.87.37-1.324.113-.675.138-1.358.137-2.04-.002-3.8 0-7.595-.003-11.393zm-6.423 3.99v5.712c0 .417-.058.827-.244 1.206-.29.59-.76.962-1.388 1.14-.35.1-.706.157-1.07.173-.95.042-1.785-.364-2.172-1.158-.39-.804-.245-1.784.503-2.39.424-.344.928-.517 1.466-.612.344-.06.692-.09 1.038-.142.2-.03.4-.07.595-.12.089-.023.167-.067.167-.183V9.967c0-.12-.04-.2-.161-.212-.038-.004-.077-.01-.115-.01-.455-.036-.91-.07-1.364-.106l-4.31-.34c-.075-.005-.15-.012-.226-.012-.09 0-.13.048-.132.138v7.63c.002.224-.022.447-.075.666-.16.664-.541 1.158-1.153 1.45a2.91 2.91 0 01-.826.253c-.862.15-1.614-.025-2.234-.632-.678-.664-.763-1.588-.378-2.343.323-.635.86-1.01 1.507-1.208.44-.135.893-.19 1.35-.248.263-.033.528-.055.79-.09.163-.023.32-.066.38-.253.023-.074.035-.153.035-.23V6.324c0-.22.063-.33.27-.392.098-.03.2-.048.302-.06l4.232-.51 3.537-.426c.08-.01.16-.018.24-.03.107-.016.17.02.196.126.012.048.017.1.017.15v4.932z"/>
      </svg>
    )
  },
  { 
    id: 'amazonMusic', 
    name: 'Amazon Music', 
    color: '#FF9900',
    icon: (
      <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor">
        <path d="M2.125 6.876C.763 7.47.763 8.53 2.125 9.124l7.667 3.834a2.5 2.5 0 002.416 0l7.667-3.834c1.362-.594 1.362-1.654 0-2.248L12.208 2.96a2.5 2.5 0 00-2.416 0L2.125 6.876zm0 6.668C.763 14.138.763 15.198 2.125 15.792l7.667 3.834a2.5 2.5 0 002.416 0l7.667-3.834c1.362-.594 1.362-1.654 0-2.248l-2.209-1.104-5.458 2.73a2.5 2.5 0 01-2.416 0l-5.458-2.73-2.209 1.104z"/>
        <path d="M3.518 19.427c0 1.042.898 1.667 1.875 1.25L19.5 14.375c.977-.417.977-1.458 0-1.875L5.393 6.198c-.977-.417-1.875.208-1.875 1.25v12.979z" opacity="0.6"/>
      </svg>
    )
  },
];

// Small icons for inline use
const SpotifyIconSmall = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
  </svg>
);

const AppleMusicIconSmall = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
    <path d="M23.994 6.124a9.23 9.23 0 00-.24-2.19c-.317-1.31-1.062-2.31-2.18-3.043a5.022 5.022 0 00-1.877-.726 10.496 10.496 0 00-1.564-.15c-.04-.003-.083-.01-.124-.013H5.986c-.152.01-.303.017-.455.026-.747.043-1.49.123-2.193.401-1.336.53-2.3 1.452-2.865 2.78-.192.448-.292.925-.363 1.408-.056.392-.088.785-.1 1.18 0 .032-.007.062-.01.093v12.223c.01.14.017.283.027.424.05.815.154 1.624.497 2.373.65 1.42 1.738 2.353 3.234 2.801.42.127.856.187 1.293.228.555.053 1.11.06 1.667.06h11.03a12.5 12.5 0 001.57-.1c.822-.106 1.596-.35 2.295-.81a5.046 5.046 0 001.88-2.207c.186-.42.293-.87.37-1.324.113-.675.138-1.358.137-2.04-.002-3.8 0-7.595-.003-11.393zm-6.423 3.99v5.712c0 .417-.058.827-.244 1.206-.29.59-.76.962-1.388 1.14-.35.1-.706.157-1.07.173-.95.042-1.785-.364-2.172-1.158-.39-.804-.245-1.784.503-2.39.424-.344.928-.517 1.466-.612.344-.06.692-.09 1.038-.142.2-.03.4-.07.595-.12.089-.023.167-.067.167-.183V9.967c0-.12-.04-.2-.161-.212-.038-.004-.077-.01-.115-.01-.455-.036-.91-.07-1.364-.106l-4.31-.34c-.075-.005-.15-.012-.226-.012-.09 0-.13.048-.132.138v7.63c.002.224-.022.447-.075.666-.16.664-.541 1.158-1.153 1.45a2.91 2.91 0 01-.826.253c-.862.15-1.614-.025-2.234-.632-.678-.664-.763-1.588-.378-2.343.323-.635.86-1.01 1.507-1.208.44-.135.893-.19 1.35-.248.263-.033.528-.055.79-.09.163-.023.32-.066.38-.253.023-.074.035-.153.035-.23V6.324c0-.22.063-.33.27-.392.098-.03.2-.048.302-.06l4.232-.51 3.537-.426c.08-.01.16-.018.24-.03.107-.016.17.02.196.126.012.048.017.1.017.15v4.932z"/>
  </svg>
);

export const Listen = ({ albums, streamingLinks, onPlayAlbum }) => {
  const latestAlbum = albums && albums.length > 0 
    ? [...albums].sort((a, b) => new Date(b.releaseDate) - new Date(a.releaseDate))[0]
    : null;

  const hasPreview = latestAlbum?.tracks?.some(t => t.previewUrl);
  const albumLinks = latestAlbum?.streamingLinks || {};

  return (
    <section id="listen" className="relative py-24 sm:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-background" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-crimson/5 rounded-full blur-[150px]" />
      <div className="absolute inset-0 grain" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12 sm:mb-16"
        >
          <span className="text-[10px] font-body uppercase tracking-[0.4em] text-crimson mb-4 block">
            Stream Everywhere
          </span>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-7xl text-ivory">
            LISTEN
          </h2>
        </motion.div>

        {/* Streaming Platforms Grid - Using latest album links */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4 mb-16 sm:mb-20"
        >
          {platforms.map((platform, index) => {
            // Use the latest album's streaming links instead of generic artist links
            const link = albumLinks?.[platform.id] || '#';
            
            return (
              <motion.a
                key={platform.id}
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ y: -5 }}
                className="flex flex-col items-center gap-3 sm:gap-4 p-6 sm:p-8 border border-border/30 bg-charcoal/30 hover:bg-charcoal/50 hover:border-border/50 transition-all duration-400 group"
              >
                <div className="text-muted-foreground group-hover:text-foreground transition-colors">
                  <div className="group-hover:scale-110 transition-transform">
                    {platform.icon}
                  </div>
                </div>
                <span className="text-sm font-body text-ivory/70 group-hover:text-ivory transition-colors">
                  {platform.name}
                </span>
              </motion.a>
            );
          })}
        </motion.div>

        {/* Featured Album */}
        {latestAlbum && (
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="relative border border-crimson/20 bg-charcoal/30 p-6 sm:p-8 md:p-12">
              <div className="flex flex-col md:flex-row gap-6 sm:gap-8 items-center">
                {/* Album Art */}
                <div className="relative w-full max-w-[200px] sm:w-48 sm:h-48 md:w-64 md:h-64 aspect-square shrink-0">
                  <img
                    src={latestAlbum.coverArtUrl}
                    alt={latestAlbum.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 border border-crimson/30" />
                  
                  {/* Play button overlay */}
                  <button
                    onClick={() => hasPreview && onPlayAlbum(latestAlbum)}
                    disabled={!hasPreview}
                    className="absolute inset-0 flex items-center justify-center bg-crimson/20 opacity-0 hover:opacity-100 transition-opacity disabled:cursor-not-allowed"
                  >
                    {hasPreview ? (
                      <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-crimson flex items-center justify-center shadow-neon">
                        <Play className="w-6 h-6 sm:w-8 sm:h-8 text-primary-foreground ml-1" />
                      </div>
                    ) : (
                      <div className="flex flex-col items-center gap-2 text-ivory/70">
                        <AlertCircle className="w-8 h-8" />
                        <span className="text-xs uppercase tracking-wider">Preview Coming Soon</span>
                      </div>
                    )}
                  </button>
                </div>

                {/* Info */}
                <div className="text-center md:text-left flex-1">
                  <span className="text-[10px] uppercase tracking-[0.3em] text-crimson font-body">
                    Latest Release • {new Date(latestAlbum.releaseDate).getFullYear()}
                  </span>
                  <h3 className="font-display text-3xl sm:text-4xl md:text-5xl text-ivory mt-2 mb-3 sm:mb-4">
                    {latestAlbum.title}
                  </h3>
                  <p className="text-sm sm:text-base text-ivory/50 font-body mb-4 sm:mb-6 max-w-md">
                    {latestAlbum.description}
                  </p>
                  
                  {/* Action Buttons */}
                  <div className="flex flex-wrap gap-3 justify-center md:justify-start mb-6">
                    <Button 
                      variant="neon" 
                      size="lg"
                      onClick={() => hasPreview && onPlayAlbum(latestAlbum)}
                      disabled={!hasPreview}
                    >
                      <Play className="w-4 h-4 mr-2" />
                      {hasPreview ? 'Preview' : 'Coming Soon'}
                    </Button>
                    {albumLinks.hyperfollow && (
                      <a href={albumLinks.hyperfollow} target="_blank" rel="noopener noreferrer">
                        <Button variant="neonOutline" size="lg">
                          <ExternalLink className="w-4 h-4 mr-2" />
                          All Platforms
                        </Button>
                      </a>
                    )}
                  </div>
                  
                  {/* Platform Quick Links */}
                  <div className="flex items-center gap-3 justify-center md:justify-start">
                    <span className="text-[10px] uppercase tracking-wider text-muted-foreground">Stream on:</span>
                    {albumLinks.spotify && (
                      <a
                        href={albumLinks.spotify}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-10 h-10 border border-border/30 flex items-center justify-center text-muted-foreground hover:text-[#1DB954] hover:border-[#1DB954]/50 transition-all"
                        title="Spotify"
                      >
                        <SpotifyIconSmall />
                      </a>
                    )}
                    {albumLinks.appleMusic && (
                      <a
                        href={albumLinks.appleMusic}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-10 h-10 border border-border/30 flex items-center justify-center text-muted-foreground hover:text-[#FA243C] hover:border-[#FA243C]/50 transition-all"
                        title="Apple Music"
                      >
                        <AppleMusicIconSmall />
                      </a>
                    )}
                  </div>
                </div>
              </div>

              {/* Corner accents */}
              <div className="absolute top-0 left-0 w-6 h-6 sm:w-8 sm:h-8 border-t border-l border-crimson/50" />
              <div className="absolute top-0 right-0 w-6 h-6 sm:w-8 sm:h-8 border-t border-r border-crimson/50" />
              <div className="absolute bottom-0 left-0 w-6 h-6 sm:w-8 sm:h-8 border-b border-l border-crimson/50" />
              <div className="absolute bottom-0 right-0 w-6 h-6 sm:w-8 sm:h-8 border-b border-r border-crimson/50" />
            </div>
          </motion.div>
        )}
      </div>
    </section>
  );
};
